import { WildNavigationType } from "../../../../../../data/enums/navigation_type";
import { FeaturesComponentListData } from "../../FeaturesData";

export const crmListData: FeaturesComponentListData = {
  image: "https://firebasestorage.googleapis.com/v0/b/wild-live.appspot.com/o/v2%2Fimagesforbrochuresite%2Fcrm%2Fcrm-seo.png?alt=media&token=29600248-87e5-4a85-843c-45e1974c3c10",
  title: "Customer Management",
  subtitle: "A CRM for Water Sports.",
  page: WildNavigationType.BUSINESSCRM,
}